/**
 * Formulaire de rétractation de la page Contact (sections/page-retraction.liquid).
 *
 * - À l'envoi : remplit le champ caché « Date et heure de la demande » (heure de Paris), qui arrive dans
 *   l'e-mail reçu par la boutique, et garde ce que le client a saisi dans sessionStorage.
 * - Au retour : le formulaire de contact de Shopify recharge la page avec ?contact_posted=true, sans les
 *   valeurs envoyées, et sans dire lequel des deux formulaires de la page a été envoyé. Si la demande
 *   vient d'ici, le script affiche le récapitulatif (contenu, date et heure) ; sinon, il remet les champs.
 *
 * Ce récapitulatif à l'écran ne remplace pas l'accusé de réception par e-mail, que la loi exige
 * (voir legal-drafts/06-fonction-retractation.md). Sans JavaScript : message de confirmation seul.
 */
(() => {
  const KEY = 'sm-withdrawal-request';
  const MAX_AGE = 30 * 60 * 1000;
  const TIME_ZONE = 'Europe/Paris';

  const read = () => {
    try {
      return JSON.parse(sessionStorage.getItem(KEY));
    } catch (error) {
      return null;
    }
  };

  const clear = () => {
    try {
      sessionStorage.removeItem(KEY);
    } catch (error) {
      // Rien à effacer.
    }
  };

  document.querySelectorAll('[data-withdrawal]').forEach((root) => {
    const form = root.querySelector('form');
    const stamp = root.querySelector('[data-withdrawal-stamp]');

    form?.addEventListener('submit', () => {
      const now = new Date();
      if (stamp) {
        stamp.value = `${new Intl.DateTimeFormat('fr-FR', {
          dateStyle: 'full',
          timeStyle: 'medium',
          timeZone: TIME_ZONE,
        }).format(now)} (heure de Paris)`;
      }
      const data = new FormData(form);
      try {
        sessionStorage.setItem(
          KEY,
          JSON.stringify({
            at: now.getTime(),
            name: data.get('contact[name]'),
            email: data.get('contact[email]'),
            order: data.get('contact[Numéro de commande]'),
            reason: data.get('contact[Motif de rétractation]'),
          })
        );
      } catch (error) {
        // Stockage refusé (navigation privée) : la confirmation s'affichera sans récapitulatif.
      }
    });

    const success = root.querySelector('[data-withdrawal-success]');
    if (!success) return;

    const body = root.querySelector('[data-withdrawal-body]');
    const request = read();

    if (!request || Date.now() - request.at > MAX_AGE) {
      // La page revient de l'autre formulaire de contact : on remet celui-ci.
      success.hidden = true;
      if (body) body.hidden = false;
      return;
    }
    clear();

    const recap = root.querySelector('[data-withdrawal-recap]');
    if (!recap) return;

    const lang = document.documentElement.lang || 'fr';
    const sentAt = new Intl.DateTimeFormat(lang, {
      dateStyle: 'long',
      timeStyle: 'short',
      timeZone: TIME_ZONE,
    }).format(new Date(request.at));

    const values = { ...request, sent_at: `${sentAt} (${root.dataset.timeZoneLabel})` };
    recap.querySelectorAll('[data-recap]').forEach((cell) => {
      cell.textContent = values[cell.dataset.recap] || '';
    });
    const reasonRow = recap.querySelector('[data-recap-row="reason"]');
    if (reasonRow && !request.reason) reasonRow.hidden = true;

    recap.hidden = false;
    root.scrollIntoView({ block: 'start', behavior: 'instant' });
  });
})();
